/**
 * API Configuration
 * Centralized configuration for API endpoints
 * 
 * This file provides a single source of truth for the API base URL.
 * The URL can be configured via environment variable VITE_API_URL,
 * or it defaults to the production API endpoint.
 */

export const API_CONFIG = {
  // Base URL for all API calls
  // Priority: Environment variable > Default production URL
  BASE_URL: import.meta.env.VITE_API_URL || 'https://api.gomens.ai/api/v1',
  
  // API version
  VERSION: 'v1',
  
  // Timeout for API requests (milliseconds)
  TIMEOUT: 30000,
};

/**
 * Get the API base URL
 * @returns {string} The configured API base URL
 */
export const getApiBaseUrl = () => API_CONFIG.BASE_URL;

/**
 * Get the full API URL for a given endpoint
 * @param {string} endpoint - The endpoint path (e.g., '/auth/login')
 * @returns {string} The full API URL
 */
export const getApiUrl = (endpoint) => {
  const baseUrl = API_CONFIG.BASE_URL;
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${cleanEndpoint}`;
};

export default API_CONFIG;
